import React from 'react';

const Forms = () => {
  return (
    <div className="forms">
      <div className="container">
        <h1>Forms</h1>
        <p>Download important forms and documents.</p>
      </div>
    </div>
  );
};

export default Forms;